const langEn = {};

export default langEn;
